const RouteConfig = {
  analytics: { path: '/analytics-v2', categories: ['analytics-v2'] },
  away: { path: '/away', categories: ['away'] },
  bsas: { path: '/bsas', categories: ['bsas'] },
  bioSafety: { path: '/use-authorization/biosafety', categories: ['biosafety'] },
  bioSafetyV2: { path: '/biosafety', categories: ['biosafety'] },
  cli: { path: '/cli', categories: ['cli'] },
  hazardSign: { path: '/hazard-sign', categories: ['chemicals'] },
  inventory: { path: '/inventory', categories: ['ppe inventory'] },
  labHazardAssessment: { path: '/lab-hazard', categories: ['lab hazard assessment'] },
  locationArea: { path: '/location-area', categories: ['locationarea'] },
  orders: { path: '/orders', categories: ['orders'] },
  loto: { path: '/loto', categories: ['procedures'] },
  medicalPlan: { path: '/medical/safety', categories: ['procedures'] },
  sph: { path: '/medical/plan/sph', categories: ['procedures'] },
  wpvp: { path: '/medical/plan/wpvp', categories: ['procedures'] },
  nfpa: { path: '/nfpa', categories: ['nfpa'] },
  profile: {
    path: '/profile',
    categories: ['profile'],
  },
  safetyPlan: { path: '/safety/plan', categories: ['procedures'] },
  sop: { path: '/sop', categories: ['procedures'] },
  tracker: { path: '/tracker', categories: ['slip-resistant'] },
  // TODO: servicedesk help category for unit risk is TBD
  unitRiskAssessment: { path: '/medical/unit-risk', categories: ['unit risk assessment'] },
  home: {
    path: '/',
    categories: ['profile'],
    childRoutes: { workspace: '/workspace', actionItems: '/action-items' },
  },
};

export default RouteConfig;
